import { ParsedAdvertisersBudgetInfoData } from '../types';

export const getStats = (data?: ParsedAdvertisersBudgetInfoData) => {
  const total = data?.totalCostBudgetMilliCent ?? 0;
  const spent = data?.totalCostBudgetUsedMilliCent ?? 0;

  const remainingMilliCents = total - spent;
  const usedPercentage = total ? (spent / total) * 100 : 0;

  return {
    remainingMilliCents,
    usedPercentage,
  };
};
